<template>
  <modal
    v-model="modalVisible"
    :title="lang.get('files.transcoding.error_header')"
    :footer="false"
    :header-close-button="false"
    @closed="$emit('closed')"
  >
    <button id="close" slot="before-content" @click.prevent="$emit('closed')">
      <i class="af-icons af-icons-cross"></i>
    </button>
    <span
      v-for="(error, i) in file.transcodingErrors"
      :key="'transcoding-error-' + i"
    >
      {{ error }}<br />
    </span>
  </modal>
</template>

<script>
import { Modal } from 'vue-bootstrap';

export default {
  inject: ['lang'],
  components: {
    Modal
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    modalVisible: {
      type: Boolean,
      default: false
    }
  }
};
</script>
